import { useIntl } from 'react-intl';
import { Box, Typography } from '@evaneos/b2b-ui';

import { DisplayDossierOverviews } from '../../../../resources/dossier/types';
import { computeBudgetSummary } from '../../utils/pipeline.utils';

const baseTypographyProps = {
    variant: 'body2',
    color: 'white',
    ['data-testid']: 'step-title-budget-sum',
} as const;

type StepTitleBudgetSumProps = {
    value: DisplayDossierOverviews;
};

export const StepTitleBudgetSum = ({ value }: StepTitleBudgetSumProps) => {
    const { formatNumber, formatMessage } = useIntl();

    const { totalBudget, budgetDisplay } = computeBudgetSummary(value);

    if (budgetDisplay === 'none') {
        return (
            <Typography {...baseTypographyProps} fontStyle="italic">
                N/A
            </Typography>
        );
    }

    if (budgetDisplay === 'insufficient') {
        return (
            <Typography {...baseTypographyProps} fontStyle="italic">
                {formatMessage({ id: 'steps.budget.insufficient_info' })}
            </Typography>
        );
    }

    const totalBudgetFormatted = formatNumber(totalBudget, {
        style: 'currency',
        minimumFractionDigits: 0,
        currency: 'EUR',
    });

    if (budgetDisplay === 'partial') {
        return (
            <Typography {...baseTypographyProps}>
                {formatMessage({ id: 'steps.budget.total' })}
                <Box component="span" fontWeight={700}>
                    {' > '}
                    {totalBudgetFormatted}
                </Box>
            </Typography>
        );
    }

    if (budgetDisplay === 'all') {
        return (
            <Typography {...baseTypographyProps}>
                {formatMessage({ id: 'steps.budget.total' })}
                <Box component="span" fontWeight={700}>
                    {' '}
                    {totalBudgetFormatted}
                </Box>
            </Typography>
        );
    }
};
